/* eslint-disable */
/* tslint:disable */
/*
 * DO NOT EDIT THIS FILE!
 * YOUR CHANGES WILL BE OVERWRITTEN!
 * FILE IS BASED ON .wuf/testkits/puppeteer.template.ejs
 * AND GENERATED BY `wuf export-testkits`
 */
import {
  puppeteerUniTestkitFactoryCreator,
} from '@wix/wix-ui-test-utils/puppeteer';
import { pupUniDriver } from '@wix/unidriver-puppeteer';
import { setUniDriverImplementation } from "../test/unidriver-config"

setUniDriverImplementation(pupUniDriver)


import { accordionDriverFactory } from '../components/Accordion/Accordion.driver';
export const accordionTestkitFactory = puppeteerUniTestkitFactoryCreator(accordionDriverFactory)

import { actionsMenuLayoutDriverFactory } from '../components/ActionsMenuLayout/ActionsMenuLayout.driver';
export const actionsMenuLayoutTestkitFactory = puppeteerUniTestkitFactoryCreator(actionsMenuLayoutDriverFactory)

import { addItemDriverFactory } from '../components/AddItem/AddItem.driver';
export const addItemTestkitFactory = puppeteerUniTestkitFactoryCreator(addItemDriverFactory)

import { avatarDriverFactory } from '../components/Avatar/Avatar.driver';
export const avatarTestkitFactory = puppeteerUniTestkitFactoryCreator(avatarDriverFactory)

import { avatarGroupDriverFactory } from '../components/AvatarGroup/AvatarGroup.driver';
export const avatarGroupTestkitFactory = puppeteerUniTestkitFactoryCreator(avatarGroupDriverFactory)

import { badgeDriverFactory } from '../components/Badge/Badge.driver';
export const badgeTestkitFactory = puppeteerUniTestkitFactoryCreator(badgeDriverFactory)

import { boxSelectionDriverFactory } from '../components/BoxSelection/BoxSelection.driver';
export const boxSelectionTestkitFactory = puppeteerUniTestkitFactoryCreator(boxSelectionDriverFactory)

import { breadcrumbsDriverFactory } from '../components/Breadcrumbs/Breadcrumbs.driver';
export const breadcrumbsTestkitFactory = puppeteerUniTestkitFactoryCreator(breadcrumbsDriverFactory)

import { buttonDriverFactory } from '../components/Button/Button.driver';
export const buttonTestkitFactory = puppeteerUniTestkitFactoryCreator(buttonDriverFactory)

import { calendarCellDriverFactory } from '../components/CalendarCell/CalendarCell.driver';
export const calendarCellTestkitFactory = puppeteerUniTestkitFactoryCreator(calendarCellDriverFactory)

import { calendarPopoverDriverFactory } from '../components/CalendarPopover/CalendarPopover.driver';
export const calendarPopoverTestkitFactory = puppeteerUniTestkitFactoryCreator(calendarPopoverDriverFactory)

import { cardDriverFactory } from '../components/Card/Card.driver';
export const cardTestkitFactory = puppeteerUniTestkitFactoryCreator(cardDriverFactory)

import { checkboxDriverFactory } from '../components/Checkbox/Checkbox.driver';
export const checkboxTestkitFactory = puppeteerUniTestkitFactoryCreator(checkboxDriverFactory)

import { checkboxGroupDriverFactory } from '../components/CheckboxGroup/CheckboxGroup.driver';
export const checkboxGroupTestkitFactory = puppeteerUniTestkitFactoryCreator(checkboxGroupDriverFactory)

import { colorPickerDriverFactory } from '../components/ColorPicker/ColorPicker.driver';
export const colorPickerTestkitFactory = puppeteerUniTestkitFactoryCreator(colorPickerDriverFactory)

import { copyUrlButtonDriverFactory } from '../components/CopyUrlButton/CopyUrlButton.driver';
export const copyUrlButtonTestkitFactory = puppeteerUniTestkitFactoryCreator(copyUrlButtonDriverFactory)

import { counterDriverFactory } from '../components/Counter/Counter.driver';
export const counterTestkitFactory = puppeteerUniTestkitFactoryCreator(counterDriverFactory)

import { counterBadgeDriverFactory } from '../components/CounterBadge/CounterBadge.driver';
export const counterBadgeTestkitFactory = puppeteerUniTestkitFactoryCreator(counterBadgeDriverFactory)

import { customDialogDriverFactory } from '../components/CustomDialog/CustomDialog.driver';
export const customDialogTestkitFactory = puppeteerUniTestkitFactoryCreator(customDialogDriverFactory)

import { datePickerInputDriverFactory } from '../components/DatePickerInput/DatePickerInput.driver';
export const datePickerInputTestkitFactory = puppeteerUniTestkitFactoryCreator(datePickerInputDriverFactory)

import { datePickerInputOldDriverFactory } from '../components/DatePickerInputOld/DatePickerInputOld.driver';
export const datePickerInputOldTestkitFactory = puppeteerUniTestkitFactoryCreator(datePickerInputOldDriverFactory)

import { dialogDriverFactory } from '../components/Dialog/Dialog.driver';
export const dialogTestkitFactory = puppeteerUniTestkitFactoryCreator(dialogDriverFactory)

import { dotNavigationDriverFactory } from '../components/DotNavigation/DotNavigation.driver';
export const dotNavigationTestkitFactory = puppeteerUniTestkitFactoryCreator(dotNavigationDriverFactory)

import { dropdownDriverFactory } from '../components/Dropdown/Dropdown.driver';
export const dropdownTestkitFactory = puppeteerUniTestkitFactoryCreator(dropdownDriverFactory)

import { eventDriverFactory } from '../components/Event/Event.driver';
export const eventTestkitFactory = puppeteerUniTestkitFactoryCreator(eventDriverFactory)

import { fileUploadDriverFactory } from '../components/FileUpload/FileUpload.driver';
export const fileUploadTestkitFactory = puppeteerUniTestkitFactoryCreator(fileUploadDriverFactory)

import { floatingDropdownDriverFactory } from '../components/FloatingDropdown/FloatingDropdown.driver';
export const floatingDropdownTestkitFactory = puppeteerUniTestkitFactoryCreator(floatingDropdownDriverFactory)

import { gridDriverFactory } from '../components/Grid/Grid.driver';
export const gridTestkitFactory = puppeteerUniTestkitFactoryCreator(gridDriverFactory)

import { heroImageDriverFactory } from '../components/HeroImage/HeroImage.driver';
export const heroImageTestkitFactory = puppeteerUniTestkitFactoryCreator(heroImageDriverFactory)

import { iconButtonDriverFactory } from '../components/IconButton/IconButton.driver';
export const iconButtonTestkitFactory = puppeteerUniTestkitFactoryCreator(iconButtonDriverFactory)

import { iconToggleDriverFactory } from '../components/IconToggle/IconToggle.driver';
export const iconToggleTestkitFactory = puppeteerUniTestkitFactoryCreator(iconToggleDriverFactory)

import { iconTooltipDriverFactory } from '../components/IconTooltip/IconTooltip.driver';
export const iconTooltipTestkitFactory = puppeteerUniTestkitFactoryCreator(iconTooltipDriverFactory)

import { imageDriverFactory } from '../components/Image/Image.driver';
export const imageTestkitFactory = puppeteerUniTestkitFactoryCreator(imageDriverFactory)

import { inputDialogDriverFactory } from '../components/InputDialog/InputDialog.driver';
export const inputDialogTestkitFactory = puppeteerUniTestkitFactoryCreator(inputDialogDriverFactory)

import { legacyCardDriverFactory } from '../components/LegacyCard/LegacyCard.driver';
export const legacyCardTestkitFactory = puppeteerUniTestkitFactoryCreator(legacyCardDriverFactory)

import { likeButtonDriverFactory } from '../components/LikeButton/LikeButton.driver';
export const likeButtonTestkitFactory = puppeteerUniTestkitFactoryCreator(likeButtonDriverFactory)

import { mediaLabelDriverFactory } from '../components/MediaLabel/MediaLabel.driver';
export const mediaLabelTestkitFactory = puppeteerUniTestkitFactoryCreator(mediaLabelDriverFactory)

import { mobileDrawerDriverFactory } from '../components/MobileDrawer/MobileDrawer.driver';
export const mobileDrawerTestkitFactory = puppeteerUniTestkitFactoryCreator(mobileDrawerDriverFactory)

import { overlappingCardDriverFactory } from '../components/OverlappingCard/OverlappingCard.driver';
export const overlappingCardTestkitFactory = puppeteerUniTestkitFactoryCreator(overlappingCardDriverFactory)

import { paginationDriverFactory } from '../components/Pagination/Pagination.driver';
export const paginationTestkitFactory = puppeteerUniTestkitFactoryCreator(paginationDriverFactory)

import { pickerDriverFactory } from '../components/Picker/Picker.driver';
export const pickerTestkitFactory = puppeteerUniTestkitFactoryCreator(pickerDriverFactory)

import { popoverDriverFactory } from '../components/Popover/Popover.driver';
export const popoverTestkitFactory = puppeteerUniTestkitFactoryCreator(popoverDriverFactory)

import { progressBarDriverFactory } from '../components/ProgressBar/ProgressBar.driver';
export const progressBarTestkitFactory = puppeteerUniTestkitFactoryCreator(progressBarDriverFactory)

import { radioButtonDriverFactory } from '../components/RadioButton/RadioButton.driver';
export const radioButtonTestkitFactory = puppeteerUniTestkitFactoryCreator(radioButtonDriverFactory)

import { radioButtonGroupDriverFactory } from '../components/RadioButtonGroup/RadioButtonGroup.driver';
export const radioButtonGroupTestkitFactory = puppeteerUniTestkitFactoryCreator(radioButtonGroupDriverFactory)

import { rangeDriverFactory } from '../components/Range/Range.driver';
export const rangeTestkitFactory = puppeteerUniTestkitFactoryCreator(rangeDriverFactory)

import { ratingsDriverFactory } from '../components/Ratings/Ratings.driver';
export const ratingsTestkitFactory = puppeteerUniTestkitFactoryCreator(ratingsDriverFactory)

import { ratingsInputDriverFactory } from '../components/RatingsInput/RatingsInput.driver';
export const ratingsInputTestkitFactory = puppeteerUniTestkitFactoryCreator(ratingsInputDriverFactory)

import { reactionsDriverFactory } from '../components/Reactions/Reactions.driver';
export const reactionsTestkitFactory = puppeteerUniTestkitFactoryCreator(reactionsDriverFactory)

import { reviewSummaryDriverFactory } from '../components/ReviewSummary/ReviewSummary.driver';
export const reviewSummaryTestkitFactory = puppeteerUniTestkitFactoryCreator(reviewSummaryDriverFactory)

import { ribbonDriverFactory } from '../components/Ribbon/Ribbon.driver';
export const ribbonTestkitFactory = puppeteerUniTestkitFactoryCreator(ribbonDriverFactory)

import { sectionNotificationDriverFactory } from '../components/SectionNotification/SectionNotification.driver';
export const sectionNotificationTestkitFactory = puppeteerUniTestkitFactoryCreator(sectionNotificationDriverFactory)

import { shareButtonDriverFactory } from '../components/ShareButton/ShareButton.driver';
export const shareButtonTestkitFactory = puppeteerUniTestkitFactoryCreator(shareButtonDriverFactory)

import { skeletonLineDriverFactory } from '../components/SkeletonLine/SkeletonLine.driver';
export const skeletonLineTestkitFactory = puppeteerUniTestkitFactoryCreator(skeletonLineDriverFactory)

import { socialBarDriverFactory } from '../components/SocialBar/SocialBar.driver';
export const socialBarTestkitFactory = puppeteerUniTestkitFactoryCreator(socialBarDriverFactory)

import { spinnerDriverFactory } from '../components/Spinner/Spinner.driver';
export const spinnerTestkitFactory = puppeteerUniTestkitFactoryCreator(spinnerDriverFactory)

import { statesButtonDriverFactory } from '../components/StatesButton/StatesButton.driver';
export const statesButtonTestkitFactory = puppeteerUniTestkitFactoryCreator(statesButtonDriverFactory)

import { stripCardDriverFactory } from '../components/StripCard/StripCard.driver';
export const stripCardTestkitFactory = puppeteerUniTestkitFactoryCreator(stripCardDriverFactory)

import { tabbedContentDriverFactory } from '../components/TabbedContent/TabbedContent.driver';
export const tabbedContentTestkitFactory = puppeteerUniTestkitFactoryCreator(tabbedContentDriverFactory)

import { tabsDriverFactory } from '../components/Tabs/Tabs.driver';
export const tabsTestkitFactory = puppeteerUniTestkitFactoryCreator(tabsDriverFactory)

import { tagDriverFactory } from '../components/Tag/Tag.driver';
export const tagTestkitFactory = puppeteerUniTestkitFactoryCreator(tagDriverFactory)

import { tagsDriverFactory } from '../components/Tags/Tags.driver';
export const tagsTestkitFactory = puppeteerUniTestkitFactoryCreator(tagsDriverFactory)

import { textAreaDriverFactory } from '../components/TextArea/TextArea.driver';
export const textAreaTestkitFactory = puppeteerUniTestkitFactoryCreator(textAreaDriverFactory)

import { textButtonDriverFactory } from '../components/TextButton/TextButton.driver';
export const textButtonTestkitFactory = puppeteerUniTestkitFactoryCreator(textButtonDriverFactory)

import { threeDotsLoaderDriverFactory } from '../components/ThreeDotsLoader/ThreeDotsLoader.driver';
export const threeDotsLoaderTestkitFactory = puppeteerUniTestkitFactoryCreator(threeDotsLoaderDriverFactory)

import { thumbnailImageDriverFactory } from '../components/ThumbnailImage/ThumbnailImage.driver';
export const thumbnailImageTestkitFactory = puppeteerUniTestkitFactoryCreator(thumbnailImageDriverFactory)

import { toastDriverFactory } from '../components/Toast/Toast.driver';
export const toastTestkitFactory = puppeteerUniTestkitFactoryCreator(toastDriverFactory)

import { toggleSwitchDriverFactory } from '../components/ToggleSwitch/ToggleSwitch.driver';
export const toggleSwitchTestkitFactory = puppeteerUniTestkitFactoryCreator(toggleSwitchDriverFactory)

import { weeklyDateNavigationDriverFactory } from '../components/WeeklyDateNavigation/WeeklyDateNavigation.driver';
export const weeklyDateNavigationTestkitFactory = puppeteerUniTestkitFactoryCreator(weeklyDateNavigationDriverFactory)

import { weeklyDatePickerDriverFactory } from '../components/WeeklyDatePicker/WeeklyDatePicker.driver';
export const weeklyDatePickerTestkitFactory = puppeteerUniTestkitFactoryCreator(weeklyDatePickerDriverFactory)

import { wowImageDriverFactory } from '../components/WowImage/WowImage.driver';
export const wowImageTestkitFactory = puppeteerUniTestkitFactoryCreator(wowImageDriverFactory)

